import React from "react";
import { Tabs } from "../../components/Tabs";
import { connect } from "react-redux";
import language from "../../language";
import { MyProfile, ChangePassword, MyFiles } from "../../components/Profile";
import Roles from "../../components/Profile/Roles";
import { ServiceAccounts } from "../../components/ServiceAccount";
import { ListContacts } from "../../components/Contacts";
import { ListBoardMembers } from "../../components/BoardMember";
import { ListBusinessAddress } from "../../components/Addresses";
import { ListDirectors } from "../../components/Directors";

class SettingScreen extends React.Component {
  render() {
    return (
      <div className="card">
        <div className="card-body">
          <Tabs
            // navMainClassName="flex-column"
            // navColumnClassName="col-md-3"
            // paneColumnClassName="col-md-8"
            options={[
              {
                title: language[this.props.defaultLanguage].my_profile,
                data: <MyProfile />,
              },
              {
                title: language[this.props.defaultLanguage].my_files,
                data: <MyFiles />,
              },
              {
                title: language[this.props.defaultLanguage].service_account,
                data: <ServiceAccounts showAdd />,
              },
              {
                title: language[this.props.defaultLanguage].contacts,
                data: <ListContacts showAdd />,
              },
              {
                title: language[this.props.defaultLanguage].address,
                data: <ListBusinessAddress showAdd />,
              },
              {
                title: language[this.props.defaultLanguage].board_members,
                data: <ListBoardMembers showAdd />,
              },
              {
                title: language[this.props.defaultLanguage].directors,
                data: <ListDirectors showAdd />,
              },
              {
                title: language[this.props.defaultLanguage].change_password,
                data: <ChangePassword />,
              },
              {
                title: language[this.props.defaultLanguage].roles_permission,
                data: <Roles />,
              },
            ]}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(SettingScreen);
